import { useMerchant } from "@/hooks/useMerchant";
import { toaster } from "@/components/ui/toaster";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useProtectTRPC } from "../trpc";

const triggerDownload = (url: string) => {
  const link = document.createElement("a");
  link.href = url;
  link.rel = "noopener";
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export function useDownloadCertificate() {
  const trpc = useProtectTRPC();
  const { merchant } = useMerchant();
  const queryClient = useQueryClient();
  const [downloadingIds, setDownloadingIds] = useState<Set<string>>(
    () => new Set()
  );

  const downloadCertificate = async (contractId: string) => {
    if (!merchant?.id || downloadingIds.has(contractId)) return;
    setDownloadingIds((prev) => new Set(prev).add(contractId));

    try {
      const url = await queryClient.fetchQuery(
        trpc.contracts.getCertificateUrl.queryOptions({
          rentalsMerchantId: merchant.id,
          id: contractId,
        })
      );
      if (!url) throw new Error("Certificate not found");
      triggerDownload(url);
    } catch {
      toaster.create({
        title: "Error",
        description: "No fue posible descargar el certificado.",
        type: "error",
        duration: 5000,
        meta: { closable: true },
      });
    } finally {
      setDownloadingIds((prev) => {
        const next = new Set(prev);
        next.delete(contractId);
        return next;
      });
    }
  };

  return { downloadCertificate, downloadingIds };
}
